/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

//https://dev.to/nnaoi/gatsby-theme-i18n-react-i18next-automatically-change-display-language-by-browser-language-when-initial-rendering-2al4

import CustomLayout from "./wrapPageElement"
import { OFFLINE_ENABLED, register as registerOffline, unregisterEverything } from "./src/utils/offline-manager"

var loadingAnim;

export const onClientEntry = (a, pluginOptions = {}) => {
    // Offline support, before the loading animation so that ?sw-reset takes
    // effect on the earliest possible tick.
    //
    // When the flag is off we do not merely skip registration - we actively tear
    // down anything already installed. A visitor who picked up a worker while
    // the feature was on would otherwise keep it for ever, since a worker only
    // goes away when something removes it. This is the client-side twin of
    // shipping the self-destructing static/sw.js.
    if (OFFLINE_ENABLED) {
        registerOffline();
    } else if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
        unregisterEverything();
    }

    loadingAnim = document.createElement("div");
    loadingAnim.style.cssText = `
    width: 100%;
    height: 2px;
    background: #AD0000;
    position: fixed;
    bottom: 0px;
    z-index: 1000;
    -webkit-animation: line_animation 2s infinite;
    animation: line_animation 2s infinite;`;

    var animKeyframes = document.createElement("style");
    animKeyframes.textContent = `@keyframes line_animation {
        0%   {left: 0px; width: 0px;}
        50%   {left: 0px; width: 100%;}
        100%   {left: 100%; width: 100%;}
    }`;

    document.body.appendChild(animKeyframes);

    document.body.appendChild(loadingAnim);
};

export const onRouteUpdateDelayed = () => {
    document.body.appendChild(loadingAnim);
}
  
export const onRouteUpdate = () => {
    loadingAnim.remove();
    window.dispatchEvent(new CustomEvent('gatsby-route-change'));
}

const isScripture = /\/(scriptures|dictionary)\/.+/;

export const shouldUpdateScroll = (data) => {
    return !data.pathname.match(isScripture);
}

/**
 * Gatsby's own registration hook stays off.
 *
 * This is not redundant with offline-config.js. Gatsby registers a worker if
 * *any* plugin's registerServiceWorker returns true, so returning false here
 * does not veto a plugin - it only declines to add our own vote. Registration is
 * done explicitly in onClientEntry below instead, which keeps the decision in
 * one place and, importantly, lets ?sw-reset run before anything installs.
 */
export const registerServiceWorker = () => false;

export const wrapPageElement = CustomLayout;